__turbopack_context__.v({
  "callout": "zepeto-instructions-modal-module__vPnAJa__callout",
  "calloutIcon": "zepeto-instructions-modal-module__vPnAJa__calloutIcon",
  "calloutLink": "zepeto-instructions-modal-module__vPnAJa__calloutLink",
  "link": "zepeto-instructions-modal-module__vPnAJa__link",
  "list": "zepeto-instructions-modal-module__vPnAJa__list",
  "title": "zepeto-instructions-modal-module__vPnAJa__title",
});
